export enum FooterClickEvent {
  Close = 'clickedClose',
  Submit = 'clickedSubmit',
  External = 'clickedExternal',
}
